// public/js/components/alert.js

export default function Alert(rootEl) {
  const closeBtn = rootEl.querySelector('[data-action="close"]');

  // Some alerts might not be dismissible
  if (!closeBtn) return;

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    // smooth fade out and slide up
    rootEl.style.transition = 'all 0.3s ease-out';
    rootEl.classList.add('opacity-0', '-translate-y-2');
    rootEl.style.marginTop = `-${rootEl.offsetHeight}px`;
    rootEl.style.marginBottom = '0px';

    // Remove from DOM after transition matches duration
    rootEl.addEventListener('transitionend', () => {
      if (rootEl.isConnected) rootEl.remove();
    }, { once: true });
    
    // Safety fallback in case transitionend fails
    setTimeout(() => {
      if (rootEl.isConnected) rootEl.remove();
    }, 300);
  });
}